module.exports = __webpack_public_path__ + "img/escala-valores.d5083288.jpg";